import { AppAction } from './types/ActionTypes'
import { SET_OPTIMIZELY_EXPERIMENT } from './actionConstants'

export function setOptimizelyExperiment(experimentId: string, experiment: App.OptimizelyExperimentDetails): AppAction {
  return (dispatch, getState) => {
    // You can access state here if needed
    const state = getState()
    if (state.optimizely.optimizelyExperiments[experimentId]?.triggered) {
      return // Already triggered, don't dispatch again
    }

    dispatch({
      type: SET_OPTIMIZELY_EXPERIMENT,
      flagKey: experimentId,
      value: {
        ...experiment,
        triggered: true,
      },
    })
  }
}
